import { isEntra, isGoogle } from "./modules/auth/idp";

// API base follows the IdP switch:
//   google → the GCP global ALB (same host serves the SPA and /xecguard/v1/*)
//   entra  → APIM
//   cognito → the AWS API behind CloudFront
const appConfig = {
  apiBaseUrl: isGoogle
    // @ts-ignore
    ? (process.env.XEC_GOOGLE_API_BASE_URL || "")
    : isEntra
      // @ts-ignore
      ? (process.env.XEC_ENTRA_API_BASE_URL || "https://apim-xecguard-dev1.azure-api.net")
      // @ts-ignore
      : (process.env.XEC_API_BASE_URL || "https://api-xecguard.cycraft.ai"),
};

export default appConfig;
